exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".csv-btn{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.csv-btn button{\n  width: 200px;\n}\n\n@media screen and (max-width: 640px) {\n  .csv-btn button{\n    width: 100%;\n  }\n  .csv-btn .csv-btn_first-btn{\n    margin-bottom: 1em;\n  }\n}\n\n:host {\n  min-height: calc(100vh - 215px);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/admin/clients/clients.component.css
// module id = ../../../../../src/app/components/admin/clients/clients.component.css
// module chunks = main